/* Jondal Produktseite: Kaufoptionen (Abo) und Creator-Video-Karussell */
(function () {
  if (window.__gPdp) return;
  window.__gPdp = true;

  /* ---------- Kaufoptionen ---------- */
  function productForm(box) {
    var root = box.closest('product-info') || document;
    return root.querySelector('form[data-type="add-to-cart-form"]');
  }

  function syncPurchase(box) {
    var checked = box.querySelector('input[data-g-mode]:checked');
    var planId = '';

    box.querySelectorAll('.g-pdp-group').forEach(function (group) {
      var radio = group.querySelector('input[data-g-mode]');
      if (!radio) return;
      var on = radio === checked;
      var opt = group.querySelector('.g-pdp-opt');
      if (opt) opt.classList.toggle('is-selected', on);

      var wrap = group.querySelector('[data-g-freq-wrap]');
      if (wrap) wrap.hidden = !on;

      var select = group.querySelector('select[data-g-freq]');
      var option = select ? select.options[select.selectedIndex] : null;
      if (option) {
        radio.value = option.value;
        var price = group.querySelector('[data-g-price]');
        if (price) price.textContent = option.getAttribute('data-price');
        var compare = group.querySelector('[data-g-compare]');
        if (compare) {
          compare.textContent = option.getAttribute('data-compare') || '';
          compare.hidden = !option.getAttribute('data-compare');
        }
        var tag = group.querySelector('[data-g-tag]');
        if (tag) {
          var save = option.getAttribute('data-save');
          tag.textContent = save ? 'Save ' + save + '%' : '';
          tag.hidden = !save;
        }
      }

      if (on) planId = radio.value;
    });

    var form = productForm(box);
    if (!form) return;
    var input = form.querySelector('input[name="selling_plan"]');
    if (planId) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }
      input.value = planId;
    } else if (input) {
      input.remove();
    }
  }

  document.addEventListener('change', function (event) {
    var box = event.target.closest && event.target.closest('[data-g-purchase]');
    if (box) syncPurchase(box);
  });

  function initPurchase() {
    document.querySelectorAll('[data-g-purchase]').forEach(syncPurchase);
  }

  /* Nach Variantenwechsel Preise aus dem neu gerenderten Abschnitt uebernehmen, Auswahl behalten */
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.html || !data.sectionId) return;
      var root = document.getElementById('MainProduct-' + data.sectionId);
      var box = root ? root.querySelector('[data-g-purchase]') : null;
      var fresh = data.html.querySelector('[data-g-purchase]');
      if (!box || !fresh) return;

      var radios = Array.prototype.slice.call(box.querySelectorAll('input[data-g-mode]'));
      var checkedIndex = radios.indexOf(box.querySelector('input[data-g-mode]:checked'));
      var selectIndexes = Array.prototype.map.call(box.querySelectorAll('select[data-g-freq]'), function (s) {
        return s.selectedIndex;
      });

      box.innerHTML = fresh.innerHTML;

      var newRadios = box.querySelectorAll('input[data-g-mode]');
      if (checkedIndex > -1 && newRadios[checkedIndex]) newRadios[checkedIndex].checked = true;
      box.querySelectorAll('select[data-g-freq]').forEach(function (s, i) {
        if (selectIndexes[i] > -1 && selectIndexes[i] < s.options.length) s.selectedIndex = selectIndexes[i];
      });
      syncPurchase(box);
    });
  }

  /* ---------- Why we love it: Video-Karussell ---------- */
  function initUgc(section) {
    if (section.__gUgc) return;
    section.__gUgc = true;
    var track = section.querySelector('[data-g-ugc-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.g-ugc__slide'));
    if (!slides.length) return;
    var inView = false;
    var active = null;

    function play(video) {
      if (!video) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function setActive(slide) {
      active = slide;
      slides.forEach(function (s) {
        var on = s === slide;
        s.classList.toggle('is-active', on);
        var video = s.querySelector('video');
        if (!video) return;
        if (on && inView) {
          play(video);
        } else {
          video.pause();
        }
      });
    }

    function closestSlide() {
      var left = track.getBoundingClientRect().left;
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var best = slides[0];
      var bestDist = Infinity;
      slides.forEach(function (s) {
        var d = Math.abs(s.getBoundingClientRect().left - left - pad);
        if (d < bestDist) {
          bestDist = d;
          best = s;
        }
      });
      return best;
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var s = closestSlide();
        if (s !== active) setActive(s);
      }, 90);
    }, { passive: true });

    slides.forEach(function (s) {
      s.addEventListener('click', function (event) {
        if (event.target.closest('[data-g-mute]')) return;
        if (s !== active) {
          track.scrollTo({ left: s.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: 'smooth' });
        }
      });
    });

    section.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-g-mute]');
      if (!btn) return;
      var video = btn.closest('.g-ugc__media').querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      btn.classList.toggle('is-unmuted', !video.muted);
      btn.setAttribute('aria-pressed', String(!video.muted));
      if (!video.muted) play(video);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        setActive(active || slides[0]);
      }, { threshold: 0.35 }).observe(section);
    } else {
      inView = true;
      setActive(slides[0]);
    }
  }

  function initAll() {
    initPurchase();
    document.querySelectorAll('[data-g-ugc]').forEach(initUgc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-g-ugc]').forEach(initUgc);
    event.target.querySelectorAll('[data-g-purchase]').forEach(syncPurchase);
  });
})();
